import * as Sentry from "@sentry/browser";
import { wasmIntegration } from "@sentry/wasm";
import { createBeforeSend, toSentryEnvironment, toSentryRelease } from "./sentryFilters.js";

const environment = toSentryEnvironment(__ENV__);

export const reportHandledFailure = (error, fingerprint) => {
  console.error(error);
  Sentry.withScope(scope => {
    scope.setLevel("warning");
    scope.setFingerprint([fingerprint]);
    Sentry.captureException(error);
  });
};

try {
  const appSettings = await import(`../../config/appsettings.${environment}.json`);
  const version = document.querySelector("meta[name='coinledger-version']")?.getAttribute("content");

  Sentry.init({
    dsn: appSettings.SentryDsn,
    environment,
    release: toSentryRelease(version),
    integrations: [wasmIntegration()],
    beforeSend: createBeforeSend({ origin: window.location.origin }),
  });
} catch (e) {
  console.error(e);
}
